import { soFetch } from 'so-fetch';
import * as constants from './location-constants';
import * as queries from './location-graphql-query';
import { del } from '../../../utils/http';
import checkStatus from '../../../utils/checkStatus';

export function getUserLocationProfile(locationId) {
  return soFetch(`/proxy/profile/locations/${locationId}?query=${queries.myLocationProfileQuery}`, {
    method: 'get',
    actionType: constants.GET_USER_LOCATION_PROFILE,
    responseBinding: 'location',
  });
}

export function deleteCoverImageFromLocation(filename, id) {
  return dispatch => {
    return fetch('/proxy/profile/delete_cover_photos', {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ filename: filename + id }),
    })
    .then(res => {
      if (res.status !== 200) throw new Error(res.status);
      return dispatch({
        type: constants.DELETE_COVER_IMAGE_FROM_LOCATION,
        payload: { id },
      });
    })
    .catch(err => console.log('err in deleting location cover photo', err));
  };
}

export function removeProduct(productId, locationId) {
  return dispatch => {
    return del(`/proxy/profile/products/${productId}`)
    .then(checkStatus)
    .then(() => dispatch({ type: constants.REMOVE_PRODUCT, payload: { productId, locationId } }))
    .catch(() => dispatch({ type: constants.REMOVE_PRODUCT_FAILED, payload: { locationId } }));
  };
}

export function importProdData(payload) {
  return dispatch => {
    dispatch({ type: constants.IMPORTING_PROD });
    return fetch(`/proxy/profile/locations/${payload.locId}/createProdFromData`, {
      method: 'post',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...payload }),
    })
    .then(checkStatus)
    .then(res => res.json())
    .then(response => dispatch({ type: constants.FINISHED_IMPORTING_PROD, payload: { locationId: payload.locId, productId: payload.prodIdToImportTo } }))
    .catch(err => console.log('err in adding prod through import', err));
  };
}

export function addProduct(name, id) {
  return soFetch(`/proxy/profile/locations/${id}/products?mutation=${queries.addProductMutation}`, {
    body: { name },
    method: 'post',
    actionType: constants.ADD_PRODUCT,
    responseBinding: 'payload',
  });
}


export function editLocationField({ updateField, updateBody, id }) {
  return dispatch => {
    let body = updateBody;
    if ((updateField === 'coverImageUrl' || updateField === 'profileImageUrl') && updateBody) {
      body += `?${Date.now()}`;
      if (updateField === 'profileImageUrl') {
        dispatch({ type: constants.PROFILE_IMAGE_CHANGED, payload: body });
      }
    }
    dispatch({
      type: constants.EDIT_USER_LOCATION_PROFILE_FIELD_STARTING,
      payload: {
        id,
        updateField,
        updateBody: body,
      },
    });
    return soFetch(`/proxy/profile/locations/${id}?mutation=${queries.editLocationMutation}`, {
      method: 'put',
      body: {
        [updateField]: body,
      },
      actionType: constants.EDIT_USER_LOCATION_PROFILE_FIELD,
      responseBinding: 'location',
    })(dispatch);
  };
}




// WEBPACK FOOTER //
// ./src/app/stores/profile/location/location-actions.js